<template>
  <section>
    <h3>Teilschritt hinzufügen</h3>
    <div class="o-grid o-grid--wrap o-grid--full@small">
      <div class="o-grid__cell o-grid__cell--width-50">
        <bos-input
          id="titleDe"
          ref="titleDe"
          label="Bezeichnung (de)"
          placeholder="Bezeichnung (de)"
          v-model="value.displayNameDe"
          :error="errors.titleDe"
          required
        />
        <bos-input
          ref="titleFr"
          label="Bezeichnung (fr)"
          placeholder="Bezeichnung (fr)"
          :error="errors.titleFr"
          v-model="value.displayNameFr"
          required
        />
        <bos-input
          ref="titleEn"
          label="Bezeichnung (en)"
          placeholder="Bezeichnung (en)"
          :error="errors.titleEn"
          v-model="value.displayNameEn"
          required
        />
      </div>
      <div class="o-grid__cell o-grid__cell--width-45 o-grid__cell--offset-5">
        <bos-input
          label="Zeitraum (von/bis)"
          type="daterange"
          v-model="value.dateRange"
          :error="errors.dateRange"
          required
        />
      </div>
      <div class="o-grid__cell o-grid__cell--width-100 u-right">
        <bos-button
          @click="clearStep"
          v-if="
            value.displayNameDe ||
              value.displayNameFr ||
              value.displayNameEn ||
              (value.dateRange &&
                (value.dateRange.start || value.dateRange.end))
          "
          >abbrechen</bos-button
        >&nbsp;
        <bos-button @click="saveStep">Teilschritt speichern</bos-button>
      </div>
    </div>
  </section>
</template>

<script>
import BosInput from './BosInput'
import BosButton from './BosButton'
import FormValidator from '../services/FormValidator'

export default {
  name: 'BosAdminStepForm',
  model: {
    prop: 'value',
    event: 'input'
  },
  data() {
    return {
      errors: {
        titleDe: {
          hasError: false
        },
        titleFr: {
          hasError: false
        },
        titleEn: {
          hasError: false
        },
        dateRange: {
          hasError: false
        }
      }
    }
  },
  components: { BosButton, BosInput },
  props: {
    value: {}
  },
  methods: {
    getValidationRules() {
      //rules
      return [
        {
          value: this.value.displayNameDe,
          required: true,
          errorKey: 'titleDe'
        },
        {
          value: this.value.displayNameFr,
          required: true,
          errorKey: 'titleFr'
        },
        {
          value: this.value.displayNameEn,
          required: true,
          errorKey: 'titleEn'
        },
        {
          value: this.value.dateRange,
          required: true,
          errorKey: 'dateRange',
          type: 'daterange'
        }
      ]
    },
    saveStep() {
      FormValidator.validateForm(this.getValidationRules(), this.errors).then(
        () => {
          this.$emit('input', this.value)
        }
      )
    },
    clearStep() {
      this.$emit('onclear', this.value)
    }
  }
}
</script>

<style lang="scss" scoped>
h3 {
  padding: 1rem;
}
</style>
